import React from 'react';
import './AsOfModal.scss';
import Trp from '../Shared/TRP/TRP';
import {
  isCollegeAnything,
  isAppBuy,
  isAppSell,
} from '../../utils/transactions-util';
import RASText from '../Shared/RASText/RASText';
import styles from '../Shared/APPText/APPText.module.scss';

const AsOfModal = ({ collegeOnly, hasAPP }) => (
  <div className="as-of-modal">
    <h4>Important Information Regarding the Updating of Account Balances</h4>
    <div id="body-text">
      <p>
        {collegeOnly || isCollegeAnything() ? (
          'Portfolio'
        ) : (
          <>
            <Trp /> mutual fund share prices and portfolio
          </>
        )}{' '}
        unit prices are calculated as of market close each business day and are
        generally updated on our website each business day between 6:30 p.m. and
        8 p.m. ET, at which time current account balances should reflect that
        updated price information.
      </p>
      {collegeOnly || isCollegeAnything() ? (
        <p />
      ) : (
        <p>
          Prices and balances for positions held in <Trp /> brokerage accounts
          and <Trp /> <RASText tradeMark /> accounts are generally updated
          overnight between 1 a.m. and 3 a.m. ET, at which time current prices
          and account balances should reflect information as of the most recent
          business day's market close.
        </p>
      )}
      {(isAppBuy() || isAppSell() || hasAPP) && (
        <p>
          T. Rowe Price ActivePlus Portfolios<sup className={styles.sup}>®</sup>
          account balances are generally updated overnight between 3:30 a.m. and
          5:30 a.m. ET, at which time account balances should reflect
          information as of the most recent business day's market close.
        </p>
      )}
      <p>
        {collegeOnly || isCollegeAnything() ? (
          'Portfolio'
        ) : (
          <>
            <Trp /> mutual fund
          </>
        )}{' '}
        transactions{' '}
        {collegeOnly || isCollegeAnything() ? 'received' : 'entered'} for your
        account(s) during the current business day will be processed overnight
        and should be available to view online and reflected in your account
        balance the following morning.{' '}
        {collegeOnly || isCollegeAnything()
          ? ''
          : 'Intraday trading activity and pending account activity in your brokerage account will not be reflected in the account balance until the following morning.'}
      </p>
    </div>
  </div>
);

export default AsOfModal;
